// Simple cache for API responses
class ApiCache {
    constructor() {
        this.cache = new Map();
        this.timestamps = new Map();
        this.ttl = 5 * 60 * 1000; // 5 minutes TTL
    }

    set(key, data) {
        this.cache.set(key, data);
        this.timestamps.set(key, Date.now());
    }

    get(key) {
        const timestamp = this.timestamps.get(key);

        // Check if cache is expired
        if (timestamp && Date.now() - timestamp > this.ttl) {
            this.cache.delete(key);
            this.timestamps.delete(key);
            return null;
        }

        return this.cache.get(key) || null;
    }

    has(key) {
        const timestamp = this.timestamps.get(key);

        if (timestamp && Date.now() - timestamp > this.ttl) {
            this.cache.delete(key);
            this.timestamps.delete(key);
            return false;
        }

        return this.cache.has(key);
    }

    clear() {
        this.cache.clear();
        this.timestamps.clear();
    }

    // Clear expired entries
    cleanup() {
        const now = Date.now();
        for (const [key, timestamp] of this.timestamps.entries()) {
            if (now - timestamp > this.ttl) {
                this.cache.delete(key);
                this.timestamps.delete(key);
            }
        }
    }
}

// Create singleton instance
const apiCache = new ApiCache();

// Cleanup expired entries every 10 minutes
setInterval(() => {
    apiCache.cleanup();
}, 10 * 60 * 1000);

export default apiCache;
